import { render, staticRenderFns } from "./FixedNotice.vue?vue&type=template&id=3ea94e28&scoped=true"
import script from "./FixedNotice.vue?vue&type=script&lang=js"
export * from "./FixedNotice.vue?vue&type=script&lang=js"
import style0 from "./FixedNotice.vue?vue&type=style&index=0&id=3ea94e28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea94e28",
  null
  
)

export default component.exports